module.exports = __webpack_public_path__ + "img/live-rtmp-tutorial-3.faafa87f.png";